import { render } from "./PretItem.vue?vue&type=template&id=2405a17b"
import script from "./PretItem.vue?vue&type=script&lang=js"
export * from "./PretItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__